import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { mutate } from "swr";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";

import { store } from "../../../components/VerticalLayout/store";
import { resetAllPeripherals } from "@pages/Applications/DeviceAssociateModal/store";
import { store as userStore } from "@components/VerticalLayout/store";
import {
    store as cashManagementStore,
    setIsActionsClicked,
    setActions,
} from "./store";

import { getUniqueId, UpdateResourceIp } from "@helpers/general";
import ErrorToast from "@components/Common/ErrorTost";
import { useFetchGlobal } from "../../../api/hooks";

type UseCashManagementConfigureProps = {
    setIsAddCashManagementClicked: Function;
    setDataIsUpdated: Function;
    isAddCashManagementClicked: boolean;
    editedData: any;
    setEditedData: Function;
    isAddNewCashManagementButtonClicked: boolean;
    shopId: number | string;
    setIsEdited: Function;
    setInputDesignation: Function;
    inputDesignation: boolean;
    setInputMarque: Function;
    inputMarque: boolean;
    inputIp: boolean;
    setInputIp: Function;
    dataTable?: any;
    localShopId?: any;
    isConsult: boolean;
    setIsConsult: Function;
};

export function useCashManagementConfigure({
    setIsAddCashManagementClicked,
    isAddCashManagementClicked,
    setDataIsUpdated,
    editedData,
    setEditedData,
    isAddNewCashManagementButtonClicked,
    shopId,
    setIsEdited,
    inputDesignation,
    setInputDesignation,
    inputMarque,
    setInputMarque,
    inputIp,
    setInputIp,
    dataTable,
    localShopId,
    isConsult,
    setIsConsult,
}: UseCashManagementConfigureProps) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { userID, franchiseID, operatorID, resourceIp } = useSnapshot(store);
    const { oneShop, shopID } = useSnapshot(userStore);
    const { isActionsClicked, isEdited } = useSnapshot(cashManagementStore);

    const [designation, setDesignation] = useState<string>("");
    const [mark, setMark] = useState<string>("");
    const [remark, setRemark] = useState<string>("");
    const [reference, setReference] = useState<string>("");
    const [ipAddress, setIpAddress] = useState<string>("");
    const [portNumber, setPortNumber] = useState<string>("");
    const [user, setUser] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [posId, setPosId] = useState<string>("");
    const [logDirectory, setLogDirectory] = useState<string>(".\\logMonnayeur");
    const [isNameExist, setIsNameExist] = React.useState<boolean>(false);
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [selectMark, setSelectMark] = React.useState<boolean>(false);
    const [inputPort, setInputPort] = React.useState<boolean>(false);
    const [inputUser, setInputUser] = React.useState<boolean>(false);
    const [inputPassword, setInputPassword] = React.useState<boolean>(false);
    const [inputPosId, setInputPosId] = React.useState<boolean>(false);
    const [ipExist, setIpExist] = React.useState<boolean>(false);
    const [emptyIp, setEmptyIp] = React.useState<boolean>(false);

    const data = {
        mark,
        ipAddress,
        portNumber,
        user,
        password,
        posId,
        logDirectory,
        setIpAddress,
        setPortNumber,
        setUser,
        setPassword,
        setPosId,
        setLogDirectory,
        inputIp,
        setInputIp,
        inputPort,
        setInputPort,
        inputUser,
        setInputUser,
        inputPassword,
        setInputPassword,
        inputPosId,
        setInputPosId,
        ipExist,
        setIpExist,
        emptyIp,
        setEmptyIp,
    };
    const pathname = window.location.pathname.toString();
    const [canValidate, setCanValidate] = React.useState<boolean>(true);
    const notStartWithSpaceRegExp = new RegExp(/^\S/);
    const matchWordDesignation = new RegExp(
        new RegExp(/^[\w]+([-_\s]{1}[A-Za-z0-9]+)*$/i)
    );
    const uuidUser = localStorage.getItem("uuidUser");
    // eslint-disable-next-line
    const CashdroReferencesArray: {
        label: string;
        value: string;
    }[] = ["EXEMPLE 1", "EXEMPLE 2", "EXEMPLE 3", "EXEMPLE 4"].map(
        (element: string) => {
            return {
                label: element,
                value: element,
            };
        }
    );
    const GloryReferencesArray: {
        label: string;
        value: string;
    }[] = ["Monnayeur CI-5", "Monnayeur CI-10"].map((element: string) => {
        return {
            label: element,
            value: element,
        };
    });

    const activateCheckbox = () => {
        let checks = document.getElementsByClassName("PrivateSwitchBase-input");
        for (let i = 0; i < checks.length; i++) {
            checks[i].classList.remove("not-allowed-icon-check__clz");
        }
    };

    function uniqueDesignation(designation: string) {
        let names: any[] = [];

        if (localShopId?.length >= 1) {
            if (dataTable?.data?.length > 0) {
                if (dataTable.data[0][t("Shop")] === undefined) {
                    dataTable.data.forEach((element: any) => {
                        names.push({
                            shopId: element.shopId,
                            name: element[t("Designation")].trim(),
                            id: element.Id,
                        });
                    });
                } else {
                    localShopId.forEach((shopId: any) => {
                        let fetchData: any = dataTable.data.find(
                            (x: any) => x.shopId === shopId
                        );
                        if (fetchData?.subRows.length > 0) {
                            fetchData?.subRows.forEach((element: any) => {
                                names.push({
                                    shopId: element.shopId,
                                    name: element[t("Designation")].trim(),
                                    id: element.Id,
                                });
                            });
                        }
                    });
                }
            }
            if (
                names.findIndex(
                    (elt: any) =>
                        elt.name.toUpperCase().trim() ===
                        designation.toUpperCase().trim()
                ) !== -1 &&
                editedData.Id === undefined
            ) {
                setIsNameExist(true);
            } else if (
                editedData.Id !== undefined &&
                names.findIndex(
                    (elt: any) =>
                        elt.name.toUpperCase().trim() ===
                            designation.toUpperCase().trim() &&
                        elt.name.toUpperCase().trim() !==
                            editedData[t("Designation")].toUpperCase().trim()
                ) !== -1
            ) {
                setIsNameExist(true);
            } else {
                setIsNameExist(false);
            }
        }
    }

    function IsExistPeripheral(data: any, des: string) {
        let res: boolean = true;
        for (let index = 0; index < data.length; index++) {
            const element = data[index][t("Designation")]?.toString();
            if (element.toUpperCase() === des.toUpperCase()) {
                res = false;
            }
        }
        return res;
    }

    async function handleValidateButtonClickEvent() {
        toast.dismiss();
        let hasIpConflict = 0;
        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/cash_management`;
        let userId: number = userID;
        let franchiseId: string = franchiseID;
        let listShopId = localShopId;
        if (localShopId.length === 0) {
            ErrorToast(`${t("Attention ! you must select a store.")!}`);
        } else {
            if (canValidate) {
                setCanValidate(false);
                try {
                    let action: boolean = false;

                    for (let index = 0; index < listShopId.length; index++) {
                        const element = listShopId[index];

                        let savedData = {
                            userId: userId,
                            shopId: element,
                            franchiseId: franchiseId,
                            operatorId: operatorID,
                            uuidUser: uuidUser,
                            data: [
                                {
                                    id: getUniqueId(10),
                                    designation: designation?.trim(),
                                    mark: mark,
                                    note: remark,
                                    reference: reference,
                                    ip: ipAddress,
                                    port_number: portNumber,
                                    user: user,
                                    password: password,
                                    server_directory: logDirectory,
                                    pos_id: posId,
                                    shopId: element,
                                    edit_date: new Date(),
                                    add_date: new Date(),
                                    isArchived: false,
                                },
                            ],
                        };
                        let filteredData = JSON.parse(
                            JSON.stringify(resourceIp)
                        )
                            ?.filter(
                                (item: any) =>
                                    item?.shopId === element &&
                                    item.ip.trim() !== ""
                            )
                            .map((y: any) => {
                                return y.ip;
                            });
                        filteredData = [...new Set(filteredData)];
                        if (filteredData.includes(ipAddress)) {
                            hasIpConflict++;
                        }
                        let dataSearch =
                            oneShop ||
                            (dataTable.data.length > 0 &&
                                dataTable.data[0][t("Shop")] === undefined) ||
                            dataTable.data.length === 0
                                ? dataTable.data
                                : dataTable.data.find((x: any) => {
                                      return x.shopId === element;
                                  }).subRows;

                        if (
                            IsExistPeripheral(
                                dataSearch,
                                designation?.trim()
                            ) &&
                            !filteredData.includes(ipAddress)
                        ) {
                            action = true;
                            try {
                                const data: any = await fetchGlobal(apiUrl, {
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify(savedData),
                                    method: "POST",
                                });
                                mutate(apiUrl, data);
                                if (data.error) {
                                    throw Error(
                                        "Error while saving selection!"
                                    );
                                }
                                setCanValidate(true);
                            } catch (error) {
                                console.error("Error saving selection:", error);
                            }
                        }
                    }
                    if (action) {
                        setDataIsUpdated(true);
                        toast.success(
                            `${t("The device is successfully added")!}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 2000,
                                theme: "colored",
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );
                    }
                    if (hasIpConflict > 0) {
                        setCanValidate(true);
                        ErrorToast(
                            t(
                                "Please note, the device could not be added to one or more stores. Please check the IP address settings."
                            )
                        );
                    }
                    resetAllPeripherals();
                    setDataIsUpdated(true);
                    UpdateResourceIp(userID, franchiseID, fetchGlobal);
                    setEditedData([]);
                    setIsEdited(false);
                    activateCheckbox();
                } catch (e: any) {
                    setCanValidate(true);
                    toast.error(`${t("There's an error")}!`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            }
        }
    }

    async function handleEditButtonClickEvent() {
        toast.dismiss();
        if (canValidate) {
            setCanValidate(false);
            const localShopIdVal = oneShop ? shopID : shopId;
            const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/peripheral/modify`;

            try {
                const data: any = await fetchGlobal(apiUrl, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        userId: userID,
                        franchiseId: franchiseID,
                        shopId: localShopIdVal,
                        operatorId: operatorID,
                        uuidUser: uuidUser,
                        peripheralType: "cash_management",
                        data: [
                            {
                                id: editedData.Id,
                                designation: designation?.trim(),
                                mark: mark,
                                reference: reference,
                                note: remark,
                                ip: ipAddress,
                                shopId: shopId,
                                port_number: portNumber,
                                user: user,
                                password: password,
                                server_directory: logDirectory,
                                pos_id: posId,
                                edit_date: new Date(),
                                add_date: "",
                                isArchived: false,
                            },
                        ],
                    }),
                    method: "PUT",
                });

                if (data.error) {
                    throw Error("Error!");
                }
                toast.success(`${t("The device is successfully changed")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    icon: <CheckboxIcon height={25} width={25} fill="white" />,
                });
                resetAllPeripherals();
                setIsAddCashManagementClicked!(!isAddCashManagementClicked);
                setDataIsUpdated(true);
                UpdateResourceIp(userID, franchiseID, fetchGlobal);
                setEditedData([]);
                setIsEdited(false);
                activateCheckbox();
            } catch (e: any) {
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
    }

    useEffect(() => {
        UpdateResourceIp(userID, franchiseID, fetchGlobal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (editedData.Id !== undefined) {
            setDesignation(editedData[t("Designation")]);
            setMark(editedData[t("Mark")]);
            setReference(editedData[t("Reference")]);
            setRemark(editedData[t("Remark")]);
            setIpAddress(editedData.ip);
            setPortNumber(editedData.port_number);
            setUser(editedData.user);
            setPassword(editedData.password);
            setPosId(editedData.pos_id);
            setLogDirectory(editedData.server_directory);
            setEmptyIp(false);
        } else {
            setDesignation("");
            setMark("");
            setReference("");
            setRemark("");
            setEmptyIp(false);
        }
        setInputDesignation(false);
        setInputMarque(false);
        setInputIp(false);
        setInputPort(false);
        setInputUser(false);
        setInputPosId(false);
        setInputPassword(false);
        setEmptyIp(false);
        setIsNameExist(false);

        // eslint-disable-next-line
    }, [editedData, isAddNewCashManagementButtonClicked, oneShop]);

    React.useEffect(() => {
        if (editedData.Id !== undefined) {
            uniqueDesignation(editedData[t("Designation")]);
        } else {
            uniqueDesignation(designation);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localShopId, editedData]);

    return {
        t,
        isActionsClicked,
        isEdited,
        setIsActionsClicked,
        setActions,
        designation,
        setDesignation,
        mark,
        setMark,
        remark,
        setRemark,
        reference,
        setReference,
        ipAddress,
        setIpAddress,
        portNumber,
        setPortNumber,
        user,
        setUser,
        password,
        setPassword,
        posId,
        setPosId,
        logDirectory,
        setLogDirectory,
        isNameExist,
        isModalOpened,
        setIsModalOpened,
        selectMark,
        setSelectMark,
        inputPort,
        setInputPort,
        inputUser,
        setInputUser,
        inputPassword,
        setInputPassword,
        inputPosId,
        setInputPosId,
        ipExist,
        setIpExist,
        emptyIp,
        setEmptyIp,
        data,
        pathname,
        canValidate,
        notStartWithSpaceRegExp,
        matchWordDesignation,
        CashdroReferencesArray,
        GloryReferencesArray,
        handleValidateButtonClickEvent,
        handleEditButtonClickEvent,
        activateCheckbox,
        uniqueDesignation,
        resetAllPeripherals,
        oneShop,
        shopID,
    };
}
